var _rect, _path, _rect2, _rect3, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1446 -551C-1446 -552.105 -1445.1 -553 -1444 -553H2738C2739.1 -553 2740 -552.105 2740 -551V703C2740 704.105 2739.1 705 2738 705H-1444C-1445.1 705 -1446 704.105 -1446 703V-551Z",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -336,
    y: -355,
    width: 390,
    height: 844,
    rx: 16,
    fill: "#0E1017"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -319,
    y: -19,
    width: 356,
    height: 54,
    rx: 7,
    fill: "#050508",
    stroke: "#1144A7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -3,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 -3H0V21H24V-3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.600098C6.62677 0.600098 2.07842 4.13159 0.549316 9.00014C2.07845 13.8686 6.62677 17.4001 11.9999 17.4001C17.3731 17.4001 21.9215 13.8686 23.4506 9.00005C21.9215 4.13156 17.3731 0.600098 12 0.600098ZM12 13.8001C14.651 13.8001 16.8 11.6511 16.8 9.0001C16.8 6.34913 14.651 4.2001 12 4.2001C9.34903 4.2001 7.2 6.34913 7.2 9.0001C7.2 11.6511 9.34903 13.8001 12 13.8001ZM14.4 9.0001C14.4 10.3256 13.3255 11.4001 12 11.4001C10.6745 11.4001 9.6 10.3256 9.6 9.0001C9.6 7.67461 10.6745 6.6001 12 6.6001C13.3255 6.6001 14.4 7.67461 14.4 9.0001Z",
    fill: "#FFB829"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1444 -552H2738V-554H-1444V-552ZM2739 -551V703H2741V-551H2739ZM2738 704H-1444V706H2738V704ZM-1445 703V-551H-1447V703H-1445ZM-1444 704C-1444.55 704 -1445 703.552 -1445 703H-1447C-1447 704.657 -1445.66 706 -1444 706V704ZM2739 703C2739 703.552 2738.55 704 2738 704V706C2739.66 706 2741 704.657 2741 703H2739ZM2738 -552C2738.55 -552 2739 -551.552 2739 -551H2741C2741 -552.657 2739.66 -554 2738 -554V-552ZM-1444 -554C-1445.66 -554 -1447 -552.657 -1447 -551H-1445C-1445 -551.552 -1444.55 -552 -1444 -552V-554Z",
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -336,
    y: -355,
    width: 390,
    height: 844,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldEye);
export default __webpack_public_path__ + "static/media/gold_eye.1d8366a8662537191de43f52a8eb7c3c.svg";
export { ForwardRef as ReactComponent };